import { formatInTimeZone } from "date-fns-tz";

/**
 * 將 Date 物件轉換為 DateTimeOffset 字串（RFC 3339，帶時區偏移量）
 * 用於 POST/PUT 送出前將表單的 Date 物件轉為後端期望的格式
 *
 * @param {Date} date
 * @param {string} timezone - 預設 "+08:00"
 * @returns {string} 例如 "2026-01-01T10:00:00+08:00"
 */
export function toDateTimeOffset(date, timezone = "+08:00") {
  return formatInTimeZone(date, timezone, "yyyy-MM-dd'T'HH:mm:ssxxx");
}
